import React from 'react';
import Dashboard from '../Dashboard';
import Customers from '../Customers';
import CustomerDetail from '../CustomerDetail';
import Subscriptions from '../Subscriptions';
import SubscriptionDetail from '../SubscriptionDetail';
import Invoices from '../Invoices';
import Credits from '../Credits';
import AIConsultant from '../AIConsultant';
import Plans from '../Plans';
import Coupons from '../Coupons';
import Reports from '../Reports';
import Settings from '../Settings';
import API from '../API';
import CheckoutCustomization from '../CheckoutCustomization';
import InvoiceDesign from '../InvoiceDesign';
import DunningManagement from '../DunningManagement';
import AbandonedCarts from '../AbandonedCarts';
import { useSettings } from '../SettingsContext';

interface AppViewRendererProps {
  activeView: string;
  setActiveView: (view: string) => void;
  selectedCustomerId: string | null;
  setSelectedCustomerId: (id: string | null) => void;
  selectedSubscriptionId: string | null;
  setSelectedSubscriptionId: (id: string | null) => void;
}

const AppViewRenderer: React.FC<AppViewRendererProps> = ({
  activeView,
  setActiveView,
  selectedCustomerId,
  setSelectedCustomerId,
  selectedSubscriptionId,
  setSelectedSubscriptionId,
}) => {
  const { settings } = useSettings();

  switch (activeView) {
    case 'dashboard':
      return <Dashboard />;
    case 'customers':
      return (
        <Customers
          onCustomerSelect={(id) => {
            setSelectedCustomerId(id);
            setActiveView('customer_detail');
          }}
        />
      );
    case 'customer_detail':
      return selectedCustomerId ? (
        <CustomerDetail
          customerId={selectedCustomerId}
          onBack={() => {
            setSelectedCustomerId(null);
            setActiveView('customers');
          }}
        />
      ) : null;
    case 'subscriptions':
      return (
        <Subscriptions
          onSubscriptionSelect={(id) => {
            setSelectedSubscriptionId(id);
            setActiveView('subscription_detail');
          }}
        />
      );
    case 'subscription_detail':
      return selectedSubscriptionId ? (
        <SubscriptionDetail
          subscriptionId={selectedSubscriptionId}
          onBack={() => {
            setSelectedSubscriptionId(null);
            setActiveView('subscriptions');
          }}
          onNavigateToCustomer={(custId) => {
            setSelectedCustomerId(custId);
            setActiveView('customer_detail');
          }}
        />
      ) : null;
    case 'invoices':
      return <Invoices />;
    case 'invoice_design':
      return <InvoiceDesign />;
    case 'usage':
      return <Credits />;
    case 'plans':
      return <Plans />;
    case 'coupons':
      return <Coupons />;
    case 'customisation':
      return <CheckoutCustomization />;
    case 'reports':
      return <Reports />;
    case 'ai':
      return settings.isAIConsultantEnabled ? <AIConsultant /> : null;
    case 'dunning':
      return <DunningManagement />;
    case 'abandoned':
      return <AbandonedCarts />;
    case 'api':
      return <API />;
    case 'settings':
      return <Settings />;
    default:
      return <Dashboard />;
  }
};

export default AppViewRenderer;
